import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import ErrorModal from "../components/UI/Error";
import { transactionService } from "../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

export default function CheckoutPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [quantity, setQuantity] = useState(1);
  const [paying, setPaying] = useState(false);
  const { plan } = location.state || {};
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user) {
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      navigate("/sign-up");
    }
  }, [user, navigate]);

  const handleQuantity = (type) => {
    setQuantity((prev) => {
      if (type === "increment") return prev + 1;
      if (type === "decrement" && prev > 1) return prev - 1;
      return prev;
    });
  };
  const handlePayment = async () => {
    try {
      setPaying(true);
      const res = await transactionService.initSubscriptionPayment({
        planId: plan._id,
        quantity,
      });
      if (res.checkoutUrl) {
        window.location.href = res.checkoutUrl;
      } else {
        setError(true);
        setPaying(false)
      }
    } catch (err) {
      setError(true);
      setPaying(false)
      console.error(err);
    }
  };
  if (!plan) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white bg-gray-400">
        <p>No plan selected.</p>
      </div>
    );
  }
  if (error) {
    return (
      <ErrorModal
        isOpen={error}
        title="Payment Error"
        message="An error occurred while processing your request. Please try again later."
        onClose={() => setError(false)}
      />
    );
  }
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-zinc-900 to-gray-700 text-white py-12 px-4">
      <div className="max-w-3xl mx-auto bg-gray-950/80 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-zinc-800">
        <h1 className="text-4xl font-bold mb-6 text-center text-yellow-500">
          🎧 Checkout
        </h1>

        <div className="mb-8">
          <h2 className="text-2xl font-semibold">{plan.name} Plan</h2>
          <p className="text-lg text-zinc-400">
            {plan.uploads} uploads per unit
          </p>
          <div className="flex items-center space-x-4 my-4">
            <span className="text-lg">Quantity:</span>
            <div className="flex items-center space-x-2 bg-zinc-800 px-3 py-2 rounded-lg">
              <button
                onClick={() => handleQuantity("decrement")}
                className="text-white hover:text-red-500">
                <FontAwesomeIcon icon={faMinus} size="xl" />
              </button>
              <span className="text-lg font-bold">{quantity}</span>
              <button
                onClick={() => handleQuantity("increment")}
                className="text-white hover:text-green-400">
                <FontAwesomeIcon icon={faPlus} size="xl" />
              </button>
            </div>
          </div>

          <p className="text-2xl font-bold mt-4">
            Total: ₦{(plan.price * quantity).toLocaleString()}
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-medium mb-2">What’s included:</h3>
          <ul className="space-y-2 text-zinc-300">
            {plan.info.map((feature, idx) => (
              <li key={idx} className="flex items-center">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  size="xl"
                  className="text-green-500 mr-2"
                />

                {feature}
              </li>
            ))}
          </ul>
        </div>

        <button
          onClick={handlePayment}
          className=" mt-6 w-full bg-green-600 hover:bg-green-700 transition-all duration-200 py-3 text-lg font-semibold rounded-xl shadow-md"
          disabled={paying}>
          {paying ? "Processing Payment" : "Proceed to Payment"}
        </button>
      </div>
    </div>
  );
}